// Footer Pop Out
function openPopUpUrl(e,t,a){return window.open(e,"","height="+t+", width="+a+", scrollbars=yes, resizable=yes");}

var zipAutofillInit = {
    'key':'AIzaSyAu_devqgFfFDvpYkTJimHzJVHiwEHjmYA',
    'selectors': '#frontpage_form',
    'country':'US',
    'citySelectAttr' : {
        'class':'form__field form__field--select',
        'required': true
    },
    'cityInputAttr': {
        'type':'text',
        'class':'form__field',
        'required': true
    }
}

$(window).load(function () {
	/* basic - default settings */
	$('.str1').liMarquee();

	/* some custom settings */
	$('.str2').liMarquee({
		direction: 'left',
		loop: -1,
		scrolldelay: 500,
		scrollamount: 90,
		circular: false,
		hoverstop: false,
		drag: false
	});

	$('.str3').liMarquee({
		direction: 'left',
		loop: -1,
		scrolldelay: 0,
		scrollamount: 100,
		circular: true,
		drag: true
	});

	$('.str3-2').liMarquee({
		direction: 'left',
		loop: -1,
		scrolldelay: 0,
		scrollamount: 120,
		circular: true,
		drag: true
	});

	$('.str4').liMarquee({
		direction: 'up',
		loop: -1,
		scrolldelay: 0,
		scrollamount: 30,
		circular: true,
		drag: true
	});

	$('.str5').liMarquee({
		direction: 'down',
		loop: -1,
		scrolldelay: 0,
		scrollamount: 30,
		circular: true,
		drag: false
	});

	$('.str6').liMarquee({
		direction: 'up',
		loop: -1,
		scrolldelay: 0,
		scrollamount: 30,
		circular: false,
		drag: true,
		runshort: false
	});


	$('.str8').liMarquee({
		direction: 'down',
		loop: -1,
		scrolldelay: 0,
		scrollamount: 30,
		circular: false,
		drag: true
	});

	$('.str9').liMarquee({
		direction: 'right'
	});

})

function initSwiper() {
	var screenWidth = $(window).width();
	if (screenWidth < 768 && mySwiper == undefined) {
		mySwiper = new Swiper('.want__slider_container', {
			spaceBetween: 0,
			freeMode: true,
			pagination: '.swiper-pagination',
			paginationClickable: true
		});
	} else if (screenWidth > 767 && mySwiper != undefined) {
		mySwiper.destroy();
		mySwiper = undefined;
		jQuery('.swiper-wrapper').removeAttr('style');
		jQuery('.swiper-slide').removeAttr('style');
	}
}

// natural slider
var mySwiper1 = $('.natural_slider').swiper({
	mode: 'horizontal',
	loop: true,
	grabCursor: true,
	pagination: '.swiper-pagination_natural',
	paginationClickable: true
});
// testimonial slider
var mySwiper1 = $('.testimonial_slider').swiper({
	mode: 'horizontal',
	loop: true,
	grabCursor: true,
	pagination: '.swiper-pagination_testimonial',
	paginationClickable: true
});

$(document).ready(function () {
            var owl = $('.owl-carousel');
            owl.owlCarousel({
                items: 4,
                loop: true,
                margin: 0,
                nav: false,
                autoplay: false,
                autoplayTimeout: 800,
                autoplayHoverPause: true,
                autoplaySpeed: 760,
                responsiveClass: true,
                autoHeight: true,
                responsive: {
                    0: {
                        items: 1,
                        dots: true,
                        nav: false,
                        autoplay: false
                    },
                    600: {
                        items: 1,
                        dots: false,
                        nav: false,
                        autoplay: false
                    },
                    992: {
                        items: 2,
                        dots: false,
                        nav: false,
                        autoplay: false
                    },
                    1200: {
                        items: 3,
                        nav: false,
                        dots: false,
                        loop: true
                    },
                    1300: {
                        items: 4,
                        nav: false,
                        dots: false,
                        loop: true
                    }
                }

            });
            $('.play').on('click', function () {
                owl.trigger('play.owl.autoplay', [1000])
            });
            $('.stop').on('click', function () {
                owl.trigger('stop.owl.autoplay')
            });

        });

// Today's Date
(function() {
	var months = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
		'October', 'November', 'December');
	var days = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
	var currentTime = new Date();
	var month = currentTime.getMonth();
	var date = currentTime.getDay();
	var day = currentTime.getDate();
	var year = currentTime.getFullYear();
	var hours = currentTime.getHours();
	var minutes = currentTime.getMinutes();
	var seconds = currentTime.getSeconds();
	document.getElementById('today-date').innerHTML = days[date] + ", " + months[month] + " " + day + ", " + year;
})();

$('.scrollToForm').click(function(){
    $('html, body').animate({scrollTop: 0}, 'slow');
});
